class AccordionOpener {
    init () {
        $('body').on('click', '.quickview-modal .js-panel-opener, .bonus-product-modal .js-panel-opener', (evt) => {
            evt.stopPropagation();
            // close other open panels
            const $allOpenPanels = $('[data-opener].open');

            const target = evt.currentTarget;
            const $panelToOpen = $(target).closest('.product-quickview').find('[data-attr="' + target.dataset.opener + '"] .js-panel').eq(0);
            // open correct panel
            if ($panelToOpen.hasClass('hidden')) {
                target.classList.add('open');
                $panelToOpen.removeClass('hidden');
            } else {
                target.classList.remove('open');
                $panelToOpen.addClass('hidden');
            }

            for (let k of $allOpenPanels) {
                k.classList.remove('open');
                const relatedPanel = k.dataset.opener;
                const $panelToClose = $('[data-attr="' + relatedPanel + '"] .js-panel');
                $panelToClose.addClass('hidden');
            }
        }).on('click', (evt) => {
            // check if the user clicked outside and the quickview is open
            const clickedOutside = $(evt.target).closest('.js-panel').length === 0
                && $('.quickview-modal').length > 0;
            if (clickedOutside) {
                const $allOpenPanels = $('[data-opener].open');
                for (let k of $allOpenPanels) {
                    k.classList.remove('open');
                    const relatedPanel = k.dataset.opener;
                    const $panelToClose = $('[data-attr="' + relatedPanel + '"] .js-panel');
                    $panelToClose.addClass('hidden');
                }
            }
        }).on('product:afterAttributeSelect', (evt) => {
            const $allOpenPanels = $('[data-opener].open');
            for (let k of $allOpenPanels) {
                const relatedPanel = k.dataset.opener;
                if (relatedPanel !== 'QNT') {
                    k.classList.remove('open');
                    const $panelToClose = $('[data-attr="' + relatedPanel + '"] .js-panel');
                    // On PDP mobile, size selection panel shouldn't be closed automatically
                    if (!$('product-wrapper--tezenis').length && Foundation.MediaQuery.atLeast('large')) {
                        $panelToClose.addClass('hidden');
                    } else if ($('.bonus-product-item').length) {
                        $panelToClose.addClass('hidden');
                    }
                }
            }
        });
    }
}
const accordion = new AccordionOpener();

document.addEventListener('DOMContentLoaded', () => {
    accordion.init();
});
